'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Create = _interopRequireDefault(require("@material-ui/icons/Create"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _DeleteJobAdModal = _interopRequireDefault(require("Modals/DeleteJobAdModal"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
_moment.default.locale('fr');
let app = window.app;
class JobAdsFront extends _react.Component {
  state = {
    loading: false,
    jobads: [],
    openDeleteJobAdModal: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchJobAds();
  }
  fetchJobAds = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    const company_id = app.state?.session?.user?.id;
    qwest.post('/job-ad/get-company-ad', {
      id: company_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        jobads: response.jobads
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  openDeleteJobAdModal = ({
    jobad_id,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteJobAdModal: true,
      delete_modal_jobad: jobad_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteJobAdModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteJobAdModal: false,
      delete_modal_jobad: undefined,
      delete_modal_trigger: undefined
    });
    component.fetchJobAds({});
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    _moment.default.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const empty_rows = state.rows_per_page - Math.min(state.rows, state.jobads_count - state.page * state.rows_per_page);
    const columns = [{
      id: 'title',
      sortable: false,
      numeric: false,
      label: 'Titre de l\'annonce',
      center: true
    }, {
      id: 'contract_type',
      sortable: false,
      numeric: false,
      label: 'Type de contrat',
      center: true
    }, {
      id: 'salary',
      sortable: false,
      numeric: false,
      label: 'Salaire',
      center: true
    }, {
      id: 'start_date',
      sortable: false,
      numeric: false,
      label: 'Date de début',
      center: true
    }, {
      id: 'updated_at',
      sortable: false,
      numeric: false,
      label: 'Dernière mise à jour',
      center: true
    }, {
      id: 'updated_at',
      sortable: false,
      numeric: false,
      label: 'Statut',
      center: true
    }, {
      id: 'actions',
      sortable: false,
      numeric: false,
      label: '',
      center: true
    }];
    const job_ads = (state.jobads || []).map(function (data) {
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: data.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.title), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.contract_type), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.salary), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, (0, _moment.default)(data.start_date).format('DD/MM/YYYY')), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, (0, _moment.default)(data.updated_at).format('DD/MM/YYYY HH:mm')), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.status), /*#__PURE__*/_react.default.createElement(_TableCell.default, null, data.status !== "Désactivée" ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "secondary",
        variant: "text",
        href: '/modifier-annonce/' + data.id,
        component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
      }, /*#__PURE__*/_react.default.createElement(_Create.default, null)), /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.openDeleteJobAdModal({
          jobad_id: data.id,
          e: e
        })
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        color: "secondary"
      }))) : undefined));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Annonces"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: component.handleRequestSort,
      order: state.order,
      order_by: state.order_by,
      row_count: job_ads.length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, job_ads, empty_rows > 0 ? /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        height: 49 * empty_rows
      }
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      colSpan: 4
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_DeleteJobAdModal.default, {
      jobad_to_delete: state.delete_modal_jobad,
      source: "front",
      open: state.openDeleteJobAdModal,
      onClose: component.closeDeleteJobAdModal,
      delete_modal_trigger: state.delete_modal_trigger
    }), loader);
    return output;
  }
}
exports.default = JobAdsFront;
